module.exports = __webpack_public_path__ + "media/img/decorations/history-year-before-b6b3598fe842de25dac7f55bcf9d041b.svg";